




















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { summaryColumns, statusMap, financingStageMap, statusSummaryMap, ifMap } from '@/utils/finance';
import { dealSummary } from '@/api/finance.js';

@Component({
  components: {}
})
class SummaryTable extends Vue {
  summaryColumns: any[] = summaryColumns;
  summaryData: any[] = [];
  visible: boolean = false;
  ifTypeList = [1, 0].map(key => ({ value: +key, name: ifMap[key] }));
  layout1 = { labelCol: { span: 5 }, wrapperCol: { span: 18 } };
  layout2 = { labelCol: { span: 20 }, wrapperCol: { span: 19 } };
  layout4 = { labelCol: { span: 20 }, wrapperCol: { span: 21 } };

  financingStageMap: any = financingStageMap;
  statusSummaryMap: any = statusSummaryMap;

  form = {};

  gutter = [16, 16];

  get summary() {
    return this.$store.state.middlePageDetail.detail;
  }

  get canModify() {
    return (this.$store.state.middlePageDetail.detail || {}).canModify;
  }

  get projectStatus() {
    return (this.$store.state.middlePageDetail.detail || {}).projectStatus;
  }

  @Watch('summary')
  initSummary(data) {
    let { projectStatus } = data;
    data.projectStatusText = statusMap[projectStatus] || '';
    this.summaryData = [data];
  }

  // 打开编辑弹窗
  handleClick() {
    this.visible = true;
    // 填充现有数据
    this.form = {
      ...this.summaryData[0]
      // financingStage: this.financingStageMap[this.summaryData[0].financingStage],
      // projectStatus: this.statusMap[this.summaryData[0].projectStatus],
      // isSmes: this.summaryData[0].isSmes === 1 ? '是' : '否',
      // nodeType: this.summaryData[0].nodeType === 1 ? 'Initial' : 'Follow-on'
    };
  }

  handleCancel() {
    this.visible = false;
  }

  async handleOk() {
    try {
      console.log(this.summaryData);

      let res = await dealSummary({
        ...this.form,
        legalCompanyId: this.summaryData[0]['projectId']
      });
      if (res.code === 200) {
        this.$message.success('保存成功');
        this.visible = false;
        // refresh data
        this.$store.dispatch('middlePageDetail/fetchDetail');
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }
}

export default SummaryTable;
